import { render, staticRenderFns } from "./dashboard-left-sidebar.html?vue&type=template&id=1451e3c6&scoped=true&external"
import script from "./dashboard-left-sidebar.js?vue&type=script&lang=js&external"
export * from "./dashboard-left-sidebar.js?vue&type=script&lang=js&external"
import style0 from "./dashboard-left-sidebar.scss?vue&type=style&index=0&id=1451e3c6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1451e3c6",
  null
  
)

export default component.exports